<template>
  <v-layout column class="page pagemargin" v-if="!isMobile()">
    <!-- Select game for analysis -->
    <v-toolbar color="secondary" v-if="!hiddenSelect">
      <v-layout wrap>
        <v-flex
          xs12
          sm12
          :class="{
              'text-xs-center': $vuetify.breakpoint.smAndDown
            }"
        >
          <span class="page-title font-weight-thin white--text">Select a game for analysis</span>
        </v-flex>
      </v-layout>
    </v-toolbar>

    <!--div>
      <pre align="left">{{ Documents }}</pre>
    </div-->

    <div v-if="!hiddenSelect" class="selectGameDiv">
      <v-flex xs12 class="gameSelector">
        <v-select
          v-model="selected"
          :items="games"
          item-text="gameName"
          item-value="id"
          attach
          label="Games"
          @input="selectGame(selected); hiddenSelect = true; hiddenAnalysis=!hiddenAnalysis"
        ></v-select>
      </v-flex>
    </div>

    <!-- Analysis page -->
    <div v-if="hiddenAnalysis">
      <notifications group="clip" position="top center"></notifications>
      <notifications group="publishedClip" position="top center"></notifications>
      <v-flex sm12 align-center justify-center class="device-main text-xs-center">
        <v-layout fluid row wrap style="height: calc(100vh - 360px)">
          <!--Video-->
          <v-flex xs12 md7>
            <v-card class="video-player" height="100%">
              <VideoScreen :options="videoOptions" />
            </v-card>
          </v-flex>
          <!--Tabs-->
          <v-flex d-flex xs12 md5>
            <v-card>
              <VideoTabs />
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12 class="device-multi">
        <v-layout fill-height row wrap>
          <!--Client panel-->
          <v-flex xs12 md9 class="client-panel">
            <v-card flat light color="grey lighten-2">
              <h3 class="client-panel-title">
                Multi function Panel -
                <b>{{clip.panelName}}</b>
              </h3>
              <v-layout row wrap pa-2>
                <v-flex xs12 class="panel-flex">
                  <VideoPanels />
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <!--Video info-->
          <v-flex xs12 sm3 md3 class="video-info">
            <v-card flat dark color="grey darken-3">
              <h3 class="video-info-title">
                Video
                <b>Info</b>
              </h3>
              <p class="video-info-content">
                Time: {{this.changeTimeFormat(clip.clipCurrentTime)}} / {{clip.clipEntireDuration}}
                <br />
                Speed: {{ClipSpeedRestrict}}x
              </p>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- Video actions -->
      <v-flex xs12 class="device-footer">
        <v-layout row wrap pa-2>
          <v-flex xs12>
            <VideoActions />
          </v-flex>
        </v-layout>
      </v-flex>
    </div>
  </v-layout>
  <v-layout column class="page pagemargin" v-else>
    <div class="error-page">
      <div>
        <p data-h1="404">404</p>
        <p data-p="forbidden">This page can't be viewed on a mobile phone.</p>
      </div>
    </div>
  </v-layout>
</template>

<script>
// @ is an alias to /src
import VideoScreen from "@/components/video/Video.vue";
import VideoTabs from "@/components/video/VideoTabs.vue";
import VideoPanels from "@/components/video/VideoPanels.vue";
import VideoActions from "@/components/video/VideoActions.vue";
import { mapState } from "vuex";
import { filestack } from "@/components/mixins/filestack.js";

export default {
  name: "VideoWindow",
  mixins: [filestack],
  components: {
    VideoScreen,
    VideoTabs,
    VideoPanels,
    VideoActions
  },
  data() {
    return {
      downloadurl: "https://cdn.filestackcontent.com/",
      games: [],
      portalList: [],
      hiddenSelect: false,
      hiddenAnalysis: false,
      selected: "",
      output: "",
      videoOptions: {
        controls: true,
        sources: [
          {
            src: ""
          }
        ]
      }
    };
  },
  computed: {
    ...mapState({
      clip: state => state.clip,
      portal: state => state.portal,
      Portals: state => state.Admin.Portals,
      Documents: state => state.Admin.Documents,
      gameID: state => state.game.gameID,
      gameVideoLink: state => state.game.videoLink,
      integration: state => state.integration
    }),
    ClipSpeedRestrict: function() {
      var twoPlaces = Math.round(this.clip.clipSpeed * 100) / 100;

      return twoPlaces;
    }
  },
  watch: {
    portal: {
      handler: function() {
        this.readGames();
      },
      deep: true
    },
    Portals: {
      handler: function() {
        this.portalList = this.Portals;
      },
      deep: true
    },
    Documents: {
      handler: function() {
        this.games = this.Documents;
      },
      deep: true
    },
    DocumentResult: {
      handler: function() {
        this.readGames();
      },
      deep: true
    },
    gameVideoLink: {
      handler: function() {
        this.videoOptions.sources = [
          {
            controls: false,
            src: this.gameVideoLink,
            type: "video/mp4",
            preload: "auto"
          }
        ];
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    changeTimeFormat(time) {
      var s = Math.floor(time % 60);
      var m = Math.floor((time / 60) % 60);
      var h = Math.floor(time / 3600);
      if (isNaN(time) || time === Infinity) {
        h = m = s = "--";
      }
      h = h > 0 ? h + ":" : "";
      m = (h && m < 10 ? "0" + m : m) + ":";
      s = s < 10 ? "0" + s : s;
      return (time = h + m + s);
    },
    readGames() {
      this.$store.dispatch("Admin/readDocuments", [
        "games",
        this.portal.active.id,
        "Admin/setDocuments"
      ]);

      // console.log("Games: " + JSON.stringify(this.Documents, null, 2));
    },
    selectGame(gameID) {
      // gameID =  gameID.toString();
      //console.log("clip state: " + JSON.stringify(this.clip, null, 2));
      console.log("clip active: " + JSON.stringify(this.clip.active, null, 2));
      this.$store.commit("game/setValue", ["gameID", gameID]);
      this.$store.commit("clip/setActiveValue", ["gameID", gameID]);
      console.log("Game id PRESSED: " + gameID);

      var i = 0;
      for (i = 0; i < this.Documents.length; i++) {
        if (gameID === this.Documents[i].id) {
          this.$store.commit("game/setValue", [
            "videoLink",
            this.createURL(this.Documents[i].videoLink.handle)
          ]);
        }
      }
      // console.log(
      //   "analysis video link: " + JSON.stringify(this.videoOptions, null, 2)
      // );

      //initialize sponsor panel
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.readGames();
  }
};
</script>

<style>
.borderg {
  border: 3px solid green;
}
.borderb {
  border: 3px solid blue;
}
.borderr {
  border: 3px solid red;
}

.device-main {
  position: absolute;
  /*z-index: 100 !important;*/
  width: 100% !important;
  left: 0px;
}

.client-panel {
  background-color: #e0e0e0 !important;
}

.client-panel-title {
  text-align: left !important;
  padding-top: 20px !important;
  padding-left: 1% !important;
}

.video-info {
  padding: 0px !important;
  background-color: #424242 !important;
}

.video-info-title {
  padding-left: 4%;
  padding-top: 20px !important;
  text-align: left !important;
}

.v-tabs__container {
  background-color: #00000040 !important;
}

.video-info-content {
  padding-left: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: left !important;
}

.device-multi {
  position: absolute;
  bottom: 150px;
  left: 0px;
  height: 150px;
  width: 100%;
}

.device-footer {
  background: #bbbbbb;
  position: absolute;
  bottom: 0px;
  left: 0px;
  height: 150px;
  width: 100%;
  padding: 0px !important;
}

.v-messages {
  display: none !important;
}

td {
  border: none !important;
}

.panel-flex {
  flex-basis: 6% !important;
}

.selectGameDiv {
  text-align: center;
  width: 100%;
  padding: 10%;
}

.gameSelector {
  margin-top: 5%;
}

.theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
  border: 2px solid #222c68;
}

@media only screen and (max-width: 959px) {
  .video-player {
    height: 300px !important;
  }
}
</style>